// extracted by mini-css-extract-plugin
export var sliderRange = "_oh-2";
export var sliderRoot = "_oh-0";
export var sliderThumb = "_oh-3";
export var sliderTrack = "_oh-1";